module.exports = __webpack_public_path__ + "static/media/dem_fac_ret_sho.51543cc4.png";